import type {
  CouponUsageSummaryResponse,
  CouponUsageUsersResponse,
} from '../types/coupon-usage.js';
import { request } from './api.js';

/**
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Marketing
 * @graph-business クーポン利用状況APIクライアント。サマリ取得とユーザー一覧取得。
 * @graph-connects /coupon-usage [calls] サマリ取得
 * @graph-connects /coupon-usage/{couponMasterId}/users [calls] ユーザー一覧取得
 */
export const couponUsageApi = {
  getSummary: (): Promise<CouponUsageSummaryResponse> => request('/coupon-usage'),
  getUsers: (couponMasterId: string): Promise<CouponUsageUsersResponse> =>
    request(`/coupon-usage/${encodeURIComponent(couponMasterId)}/users`),
};
